import { useState } from "react";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import SectionHeader from "@/components/SectionHeader";

export const Testimonials = ({ testimonials = [] }) => {
  const [i, setI] = useState(0);
  if (!testimonials.length) return null;
  const t = testimonials[i];
  const go = (dir) => setI((p) => (p + dir + testimonials.length) % testimonials.length);

  return (
    <section data-testid="testimonials-section" className="py-24 lg:py-32 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeader index="05" eyebrow="Kind words" title="What people say" />

        <div className="mt-14 rounded-2xl border border-white/10 bg-surface p-8 sm:p-12 lg:p-16">
          <Quote size={40} className="text-cream/30 mb-8" />
          <div className="min-h-[160px] sm:min-h-[140px]">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={i}
                data-testid={`testimonial-${i}`}
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -14 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              >
                <p className="font-heading font-light text-2xl sm:text-3xl lg:text-4xl leading-snug tracking-tight text-cream text-balance">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <footer className="mt-8 flex items-center gap-4">
                  <div className="h-11 w-11 rounded-full bg-cream text-ink flex items-center justify-center font-heading font-medium">
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <p className="text-cream font-medium">{t.name}</p>
                    <p className="text-ash text-sm">{t.title} · {t.company}</p>
                  </div>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <div className="mt-10 flex items-center justify-between">
            <span className="text-ash text-sm tabular-nums">
              {String(i + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
            </span>
            <div className="flex gap-3">
              <button
                onClick={() => go(-1)}
                data-testid="testimonial-prev"
                aria-label="Previous testimonial"
                className="h-11 w-11 rounded-full border border-white/20 flex items-center justify-center text-cream hover:bg-white/10 transition-colors"
              >
                <ArrowLeft size={18} />
              </button>
              <button
                onClick={() => go(1)}
                data-testid="testimonial-next"
                aria-label="Next testimonial"
                className="h-11 w-11 rounded-full border border-white/20 flex items-center justify-center text-cream hover:bg-white/10 transition-colors"
              >
                <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
